import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class NewProductService {

  constructor(private http: HttpClient) {}

  getProductTypes(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/products/types`);
  }
  addProduct(productData: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/api/new-product`, productData);
  }

}
